<template>
  <ErrorPage :code="errorCode" recover-from-nuxt-error />
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import ErrorPage from '~/components/ErrorPage.vue';
import { normalizeErrorPageCode } from '~/utils/errorPages';

const props = defineProps<{
  error: NuxtError;
}>();

const errorCode = computed(() =>
  normalizeErrorPageCode(props.error?.statusCode, 500),
);
</script>
